export const RolesUsuario = {
  MasterRole: 'MASTER',
  AdministradorRole: 'Administrador',
  OperadorRole: 'AD-Operador',
  CobranzaRole: 'AD-Cobranza',
  ContabilidadRole: 'AD-Contabilidad',
  CuentasXPagarRole: 'AD-CuentasP',
  AD_Consultor: 'AD-Consultor',
  DireccionMedicaRole: 'DireccionMedica',
  AgenteRole: 'AGENTE',
  PromotorRole: 'PROMOTOR',
  OdemRole: 'ODEM',
  Asociado: 'Asociado',
  PreSolicitud: 'PreSolicitud',
};
